import { render } from "./profileModal.vue?vue&type=template&id=00d2c5ca&scoped=true&ts=true"
import script from "./profileModal.vue?vue&type=script&lang=ts"
export * from "./profileModal.vue?vue&type=script&lang=ts"

import "./profileModal.vue?vue&type=style&index=0&id=00d2c5ca&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d2c5ca"]])

export default __exports__